/* eyebuddy-rx-flow.js — EyeBuddy Rx wizard (Phase 2).
   Ported from eyebuddy-rx-flow-prototype.html. Catalogs/copy come from the
   section's JSON config (section settings + blocks). Cart:
   - no Rx file  -> POST /cart/add.js (JSON, all items, shared _pair_id)
   - Rx file     -> multipart POST /cart/add.js for the frame line (file rides
                    as properties[Rx File]) + JSON POST for lens/add-ons.
   NO discount logic here — 2nd-frame 50% is a Shopify automatic discount. */
(function () {
  'use strict';

  var root = document.querySelector('[data-eb-rxflow]');
  if (!root || root.dataset.ebInit) return;
  root.dataset.ebInit = '1';

  var CFG;
  try {
    CFG = JSON.parse(root.querySelector('[data-eb-rxflow-config]').textContent);
  } catch (e) {
    console.error('[eb-rxflow] bad config JSON', e);
    return;
  }

  /* ---------- helpers ---------- */
  var $ = function (sel) { return root.querySelector(sel); };
  var money = function (n) { return '$' + Number(n).toFixed(2) + ' USD'; };
  var fmtP = function (v) { var n = parseFloat(v); return (n > 0 ? '+' : '') + n.toFixed(2); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  function toast(msg) {
    var t = $('[data-eb-toast]');
    t.textContent = msg;
    t.classList.add('eb-toast--show');
    setTimeout(function () { t.classList.remove('eb-toast--show'); }, 2200);
  }

  /* ---------- Rx reuse stash (sessionStorage only, 2h TTL) ----------
     Saved when a pair is added; offered as an explicit CHOICE on the Rx step
     (never auto-prefilled); cleared as soon as checkout begins. */
  var RX_STASH_KEY = 'eb-rx-stash';
  var RX_STASH_TTL = 2 * 60 * 60 * 1000;
  function rxStashLoad() {
    try {
      var s = JSON.parse(sessionStorage.getItem(RX_STASH_KEY));
      if (!s || !s.ts || (Date.now() - s.ts) > RX_STASH_TTL) return null;
      if (!s.od || !s.os) return null;
      return s;
    } catch (e) { return null; }
  }
  function rxStashSave() {
    try {
      sessionStorage.setItem(RX_STASH_KEY, JSON.stringify({
        od: { sph: state.rx.od.sph, cyl: state.rx.od.cyl, axis: state.rx.od.axis },
        os: { sph: state.rx.os.sph, cyl: state.rx.os.cyl, axis: state.rx.os.axis },
        pdMode: state.rx.pdMode, pd: state.rx.pd, pdR: state.rx.pdR, pdL: state.rx.pdL,
        ts: Date.now()
      }));
    } catch (e) {}
  }
  function rxStashClear() { try { sessionStorage.removeItem(RX_STASH_KEY); } catch (e) {} }
  function rxStashSummary(s) {
    var eye = function (e) {
      var ax = parseFloat(e.cyl) !== 0 && e.axis ? ' | x' + String(e.axis).padStart(3, '0') : '';
      return fmtP(e.sph) + ' | ' + fmtP(e.cyl) + ax;
    };
    var pd = s.pdMode === 'dual' ? 'Dual | R ' + s.pdR + ' / L ' + s.pdL : 'Single | ' + s.pd;
    return 'OD ' + eye(s.od) + '  ·  OS ' + eye(s.os) + '  ·  PD ' + pd;
  }

  /* ---------- frame (selected variant follows the theme's product form) ---------- */
  function themeVariantInput() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].hasAttribute('data-eb-form')) continue;
      var el = forms[i].querySelector('[name="id"]');
      if (el) return el;
    }
    return null;
  }
  function currentVariant() {
    var el = themeVariantInput();
    var id = el ? Number(el.value) : CFG.frame.firstAvailable;
    var v = null;
    for (var i = 0; i < CFG.frame.variants.length; i++) {
      if (CFG.frame.variants[i].id === id) { v = CFG.frame.variants[i]; break; }
    }
    if (!v) v = CFG.frame.variants[0];
    return v;
  }
  function frameName(v) {
    return CFG.frame.hasOnlyDefaultVariant ? CFG.frame.title : CFG.frame.title + ' - ' + v.title;
  }

  /* ---------- state ---------- */
  var state = {
    type: null, method: null, lens: null, addons: [], notes: '', forName: '',
    rx: {
      od: { sph: '0.00', cyl: '0.00', axis: '' },
      os: { sph: '0.00', cyl: '0.00', axis: '' },
      pdMode: 'single', pd: '', pdR: '', pdL: '',
      file: '', confirmedStrong: false
    },
    added: false, busy: false, rxStashDismissed: false
  };
  var stepIdx = 0;

  /* Add-ons are available only when the section emitted at least one. Hiding all
     Add-on blocks in the theme editor (or unticking "Enable add-ons step")
     produces an empty CFG.addons, in which case the "Complete the Pair" step is
     dropped from the flow entirely rather than rendering an empty screen.
     Progress width and the "Step X of Y" label both derive from flowSteps(),
     so removing the step renumbers everything automatically. */
  function hasAddons() { return !!(CFG.addons && CFG.addons.length); }

  function flowSteps() {
    var steps;
    if (state.type === 'frame') steps = ['type', 'addons', 'review'];
    else if (state.type === 'nonrx') steps = ['type', 'lens', 'addons', 'review'];
    else if (state.type === 'prescription' || state.type === 'sunglasses') steps = ['type', 'rx', 'lens', 'addons', 'review'];
    else return ['type'];
    if (!hasAddons()) steps = steps.filter(function (s) { return s !== 'addons'; });
    return steps;
  }
  var cur = function () { return flowSteps()[stepIdx]; };

  /* ---------- rules engine (ported verbatim) ---------- */
  function worseEye() {
    var a = Math.abs(parseFloat(state.rx.od.sph) || 0), b = Math.abs(parseFloat(state.rx.os.sph) || 0);
    var ca = Math.abs(parseFloat(state.rx.od.cyl) || 0), cb = Math.abs(parseFloat(state.rx.os.cyl) || 0);
    return { sph: Math.max(a, b), cyl: Math.max(ca, cb) };
  }
  function compatible(lens) {
    if (state.type !== 'prescription' && state.type !== 'sunglasses') return { ok: true };
    if (state.method !== 'manual') return { ok: true };
    var w = worseEye();
    var sph = parseFloat(lens.sph), cyl = parseFloat(lens.cyl);
    if (!isNaN(sph) && w.sph > sph) return { ok: false, why: 'Rx too strong for this lens (up to ±' + sph.toFixed(2) + ')' };
    if (!isNaN(cyl) && w.cyl > cyl) return { ok: false, why: 'CYL exceeds this lens (up to −' + cyl.toFixed(2) + ')' };
    return { ok: true };
  }
  function isBlue(l) { return l.blue === true || /blue/i.test(l.name); }
  function screenPickId(list, recId) {
    var pool = list.filter(function (l) { return compatible(l).ok && isBlue(l) && l.id !== recId; });
    if (!pool.length) return null;
    return pool.slice().sort(function (a, b) { return Number(a.price) - Number(b.price); })[0].id;
  }
  function recommendedId(list) {
    if (state.method !== 'manual') return null;
    var w = worseEye();
    var pool = list.filter(function (l) { return compatible(l).ok; });
    if (!pool.length) return null;
    var l;
    if (w.sph > 6) { l = pool.find(function (x) { return parseFloat(x.index) >= 1.74; }); if (l) return l.id; }
    if (w.sph > 4) { l = pool.find(function (x) { return parseFloat(x.index) >= 1.67; }); if (l) return l.id; }
    return pool.slice().sort(function (a, b) { return Number(a.price) - Number(b.price); })[0].id;
  }

  /* ---------- option builders ---------- */
  function opts(sel, from, to, step, fmt, chosen, blank) {
    var h = blank ? '<option value="">Choose</option>' : '';
    var dir = from > to ? -1 : 1;
    for (var v = from; dir > 0 ? v <= to + 1e-9 : v >= to - 1e-9; v += step * dir) {
      var val = v.toFixed(step < 1 ? 2 : 0);
      h += '<option value="' + val + '"' + (val === chosen ? ' selected' : '') + '>' + (fmt ? fmt(val) : val) + '</option>';
    }
    sel.innerHTML = h;
  }

  /* ---------- render ---------- */
  function render() {
    var steps = flowSteps();
    $('[data-eb-bar]').style.width = ((stepIdx + 1) / steps.length * 100) + '%';
    $('[data-eb-stepname]').textContent = 'Step ' + (stepIdx + 1) + ' of ' + steps.length;
    $('[data-eb-back]').disabled = stepIdx === 0 || state.added;
    var el = $('[data-eb-step]');
    ({ type: renderType, rx: renderRx, lens: renderLens, addons: renderAddons, review: renderReview })[cur()](el);
    syncSummary(); syncNext();
  }

  function renderType(el) {
    var items = [
      { k: 'prescription', ic: '👓', t: 'Prescription', d: "Single-vision lenses made to your child's Rx" },
      { k: 'sunglasses', ic: '🕶️', t: 'Sunglasses', d: "Tinted lenses with your child's Rx" },
      { k: 'nonrx', ic: '✨', t: 'Non-Prescription', d: 'No Rx — clear, blue-light, or sun' },
      { k: 'frame', ic: '🖼️', t: 'Frame Only', d: 'Just the frame, no lenses' }
    ];
    el.innerHTML = '<h2>Choose Your Prescription Type</h2>' + items.map(function (i) {
      return '<button type="button" class="eb-choice' + (state.type === i.k ? ' eb-choice--selected' : '') + '" data-k="' + i.k + '">' +
        '<span class="eb-ic">' + i.ic + '</span><span><div class="eb-t">' + i.t + '</div><div class="eb-d">' + i.d + '</div></span></button>';
    }).join('');
    el.querySelectorAll('.eb-choice').forEach(function (b) {
      b.onclick = function () {
        if (state.type !== b.dataset.k) { state.type = b.dataset.k; state.lens = null; }
        state.method = (b.dataset.k === 'prescription' || b.dataset.k === 'sunglasses') ? 'manual' : null;
        advance();
      };
    });
  }

  function eyeBlock(which, label) {
    return '<div class="eb-eye"><h3>' + label + '</h3><div class="eb-grid3">' +
      '<div><label class="eb-f">SPH</label><select data-eye="' + which + '" data-f="sph"></select></div>' +
      '<div><label class="eb-f">CYL</label><select data-eye="' + which + '" data-f="cyl"></select></div>' +
      '<div><label class="eb-f">AXIS</label><select data-eye="' + which + '" data-f="axis"></select></div>' +
      '</div><div class="eb-fielderr" data-err="' + which + '" style="display:none"></div></div>';
  }

  function renderRx(el) {
    var R = CFG.ranges;
    var stash = (!state.rxStashDismissed && !state.added) ? rxStashLoad() : null;
    el.innerHTML = '<h2>Enter the Prescription</h2>' +
      (stash ? '<div class="eb-rxreuse" data-eb-rxreuse>' +
        '<p class="eb-rxreuse__title">Use the prescription you just entered?</p>' +
        '<p class="eb-rxreuse__vals">' + esc(rxStashSummary(stash)) + '</p>' +
        '<button type="button" class="eb-cta eb-rxreuse__use" data-eb-rxreuse-use>Use this prescription</button>' +
        '<button type="button" class="eb-skiplink" data-eb-rxreuse-no>Enter a different one</button>' +
        '</div>' : '') +
      eyeBlock('od', 'OD (Right Eye)') + eyeBlock('os', 'OS (Left Eye)') +
      '<hr class="eb-sep"><h3 style="margin:0 0 4px">Pupillary Distance (PD)</h3>' +
      '<div class="eb-pdrow">' +
      '<label><input type="radio" name="eb-pdm" value="single"' + (state.rx.pdMode === 'single' ? ' checked' : '') + '> Single PD</label>' +
      '<label><input type="radio" name="eb-pdm" value="dual"' + (state.rx.pdMode === 'dual' ? ' checked' : '') + '> Dual PD</label>' +
      '</div><div data-eb-pdarea></div>' +
      '<div class="eb-fielderr" data-err="pd" style="display:none"></div>' +
      '<div data-eb-strongwarn></div>' +
      '<hr class="eb-sep">' +
      '<p class="eb-hint"><b>' + esc(CFG.copy.attachHint).split(':')[0] + ':</b>' + esc(CFG.copy.attachHint).split(':').slice(1).join(':') + '</p>' +
      '<p class="eb-attach-row"><span>🔒</span><span>' + esc(CFG.copy.privacyNote) + '</span></p>' +
      '<button type="button" class="eb-ghost" data-eb-attach style="margin-top:0">' +
      (state.rx.file ? '📎 ' + esc(state.rx.file) + ' — tap to change' : '📎 Choose photo or PDF') + '</button>' +
      '<div class="eb-fielderr" data-eb-fileerr style="display:none"></div>';

    el.querySelectorAll('select').forEach(function (s) {
      var eye = s.dataset.eye, f = s.dataset.f, v = state.rx[eye][f];
      if (f === 'sph') opts(s, parseFloat(R.sphMin), parseFloat(R.sphMax), R.step, fmtP, v, false); // most-negative at top
      if (f === 'cyl') opts(s, 0, parseFloat(R.cylMin), R.step, fmtP, v, false);
      if (f === 'axis') { opts(s, 1, 180, 1, function (x) { return x; }, v, true); s.disabled = parseFloat(state.rx[eye].cyl) === 0; }
      s.onchange = function () {
        state.rx[eye][f] = s.value; state.rx.confirmedStrong = false; state.lens = null;
        if (f === 'cyl') { if (parseFloat(s.value) === 0) state.rx[eye].axis = ''; renderRx(el); }
        else { validateRx(el); }
        syncNext();
      };
    });
    el.querySelectorAll('input[name=eb-pdm]').forEach(function (r) {
      r.onchange = function () { state.rx.pdMode = r.value; renderRx(el); syncNext(); };
    });
    var fileInput = $('[data-eb-rxfile]');
    el.querySelector('[data-eb-attach]').onclick = function () { fileInput.click(); };
    fileInput.onchange = function (e) {
      var f = e.target.files[0]; if (!f) return;
      var err = el.querySelector('[data-eb-fileerr]');
      if (f.size > 10 * 1024 * 1024) {
        err.textContent = 'File is over 10 MB — please use a smaller photo.';
        err.style.display = 'block';
        fileInput.value = '';
        return;
      }
      err.style.display = 'none';
      state.rx.file = f.name;
      el.querySelector('[data-eb-attach]').textContent = '📎 ' + f.name + ' — tap to change';
    };
    var useBtn = el.querySelector('[data-eb-rxreuse-use]');
    if (useBtn) useBtn.onclick = function () {
      var sv = rxStashLoad();
      state.rxStashDismissed = true; // choice made either way
      if (sv) {
        state.rx.od = { sph: sv.od.sph, cyl: sv.od.cyl, axis: sv.od.axis || '' };
        state.rx.os = { sph: sv.os.sph, cyl: sv.os.cyl, axis: sv.os.axis || '' };
        state.rx.pdMode = sv.pdMode === 'dual' ? 'dual' : 'single';
        state.rx.pd = sv.pd || ''; state.rx.pdR = sv.pdR || ''; state.rx.pdL = sv.pdL || '';
        state.rx.confirmedStrong = false; state.lens = null;
      }
      renderRx(el); syncNext(); // fields stay editable; validation runs as normal
    };
    var noBtn = el.querySelector('[data-eb-rxreuse-no]');
    if (noBtn) noBtn.onclick = function () { state.rxStashDismissed = true; renderRx(el); syncNext(); };
    renderPd(el); validateRx(el); syncNext();
  }

  function renderPd(el) {
    var a = el.querySelector('[data-eb-pdarea]'), R = CFG.ranges;
    if (state.rx.pdMode === 'single') {
      a.innerHTML = '<div style="max-width:220px"><label class="eb-f">PD</label><select data-eb-pd1></select></div>';
      var s = a.querySelector('[data-eb-pd1]');
      opts(s, parseFloat(R.pdMin), parseFloat(R.pdMax), R.pdStep, function (x) { return x; }, state.rx.pd, true);
      s.onchange = function (e) { state.rx.pd = e.target.value; validateRx(el); syncNext(); };
    } else {
      a.innerHTML = '<div class="eb-grid3" style="grid-template-columns:1fr 1fr;max-width:340px">' +
        '<div><label class="eb-f">Right (OD)</label><select data-eb-pdr></select></div>' +
        '<div><label class="eb-f">Left (OS)</label><select data-eb-pdl></select></div></div>';
      var r = a.querySelector('[data-eb-pdr]'), l = a.querySelector('[data-eb-pdl]');
      opts(r, parseFloat(R.dpdMin), parseFloat(R.dpdMax), R.pdStep, function (x) { return x; }, state.rx.pdR, true);
      opts(l, parseFloat(R.dpdMin), parseFloat(R.dpdMax), R.pdStep, function (x) { return x; }, state.rx.pdL, true);
      r.onchange = function (e) { state.rx.pdR = e.target.value; validateRx(el); syncNext(); };
      l.onchange = function (e) { state.rx.pdL = e.target.value; validateRx(el); syncNext(); };
    }
  }

  function rxProblems() {
    var p = {};
    ['od', 'os'].forEach(function (eye) {
      var cyl = parseFloat(state.rx[eye].cyl);
      if (cyl !== 0 && !state.rx[eye].axis) p[eye] = 'AXIS is required when CYL is not 0.00.';
    });
    if (state.rx.pdMode === 'single') { if (!state.rx.pd) p.pd = 'Please choose a PD.'; }
    else {
      if (!state.rx.pdR || !state.rx.pdL) p.pd = 'Please choose both PD values.';
      else if (Math.abs(parseFloat(state.rx.pdR) - parseFloat(state.rx.pdL)) > 4) p.pdWarn = 'Right and left PD differ by more than 4 mm — worth double-checking.';
    }
    var w = worseEye();
    if (w.sph >= parseFloat(CFG.strong.sph) || w.cyl >= parseFloat(CFG.strong.cyl)) p.strong = true;
    return p;
  }
  function validateRx(el) {
    var p = rxProblems();
    ['od', 'os'].forEach(function (eye) {
      var box = el.querySelector('[data-err="' + eye + '"]');
      box.style.display = p[eye] ? 'block' : 'none'; box.textContent = p[eye] || '';
    });
    var pd = el.querySelector('[data-err="pd"]');
    if (p.pd) { pd.style.display = 'block'; pd.className = 'eb-fielderr'; pd.textContent = p.pd; }
    else if (p.pdWarn) { pd.style.display = 'block'; pd.className = 'eb-fieldwarn'; pd.textContent = p.pdWarn; }
    else pd.style.display = 'none';
    el.querySelector('[data-eb-strongwarn]').innerHTML = p.strong ?
      '<div class="eb-confirmbox"><input type="checkbox" id="eb-strongok"' + (state.rx.confirmedStrong ? ' checked' : '') + '>' +
      '<label for="eb-strongok"><b>Strong prescription.</b> Please double-check each value against the written Rx, then confirm.</label></div>' : '';
    var cb = el.querySelector('#eb-strongok');
    if (cb) cb.onchange = function () { state.rx.confirmedStrong = cb.checked; syncNext(); };
  }
  function rxValid() {
    var p = rxProblems();
    if (p.od || p.os || p.pd) return false;
    if (p.strong && !state.rx.confirmedStrong) return false;
    return true;
  }

  function thicknessSVG(lens) {
    var w = worseEye();
    var base = Math.min(1, (w.sph || 1) / 12);
    var ix = parseFloat(lens.index) || 1.61;
    var idx = ix >= 1.74 ? 0.45 : ix >= 1.67 ? 0.7 : 1;
    var t = 4 + 22 * base * idx;
    return '<svg width="46" height="64" viewBox="0 0 46 64" aria-hidden="true">' +
      '<path d="M ' + (23 - t / 2) + ' 4 Q ' + (23 - t / 2 - 6) + ' 32 ' + (23 - t / 2) + ' 60 L ' + (23 + t / 2) + ' 60 Q ' + (23 + t / 2 + 6) + ' 32 ' + (23 + t / 2) + ' 4 Z"' +
      ' fill="#EAF2FB" stroke="#B9CBE2" stroke-width="2"/></svg>';
  }

  function catalogFor() {
    return state.type === 'nonrx' ? CFG.catalogs.nonrx :
      state.type === 'sunglasses' ? CFG.catalogs.sunglasses : CFG.catalogs.prescription;
  }

  function renderLens(el) {
    var list = catalogFor();
    var rec = state.type === 'nonrx' ? null : recommendedId(list);
    var screen = screenPickId(list, rec);
    var anyCompat = list.some(function (l) { return compatible(l).ok; });
    el.innerHTML = '<h2>Choose Your Lenses</h2>' +
      '<div class="eb-qualitybar"><span class="eb-qfox">🦊</span><span>' + CFG.copy.qualityBanner.replace(/^All genuine Japanese MR-8/, '<b>All genuine Japanese MR-8</b>') + '</span></div>' +
      (anyCompat ? '' : '<div class="eb-deadend"><b>This prescription is outside our current lens range.</b><br>' +
        '<span class="eb-hint">Contact us at ' + esc(CFG.copy.contactEmail) + ' — we can often special-order.</span></div>') +
      list.map(function (l) {
        var c = compatible(l);
        var showThick = l.index && state.method === 'manual';
        return '<button type="button" class="eb-choice' + (state.lens === l.id ? ' eb-choice--selected' : '') + (c.ok ? '' : ' eb-choice--incompat') + '" data-k="' + l.id + '"' + (c.ok ? '' : ' disabled') + '>' +
          (showThick ? thicknessSVG(l) : '<span class="eb-ic">🔍</span>') +
          '<span><div class="eb-t">' + esc(l.name) +
          (rec === l.id ? '<span class="eb-badge">Recommended</span>' : '') +
          (screen === l.id ? '<span class="eb-badge eb-badge--screen">Best for screen time</span>' : '') +
          '</div><div class="eb-d">' + esc(l.desc || '') + '</div>' + (c.ok ? '' : '<div class="eb-why">' + esc(c.why) + '</div>') + '</span>' +
          '<span class="eb-price' + (Number(l.price) === 0 ? ' eb-price--free' : '') + '">' + (Number(l.price) === 0 ? 'FREE' : money(l.price)) + '</span></button>';
      }).join('');
    el.querySelectorAll('.eb-choice:not([disabled])').forEach(function (b) {
      b.onclick = function () { state.lens = b.dataset.k; advance(); };
    });
  }

  function renderAddons(el) {
    el.innerHTML = '<h2>Complete the Pair</h2>' +
      '<p class="eb-hint" style="text-align:center;margin-top:-8px">Optional extras — tap any that help. Kids are kids.</p>' +
      CFG.addons.map(function (a) {
        var on = state.addons.indexOf(a.id) !== -1;
        return '<button type="button" class="eb-choice' + (on ? ' eb-choice--selected' : '') + '" data-k="' + a.id + '">' +
          '<span class="eb-check">' + (on ? '✓' : '') + '</span>' +
          '<span><div class="eb-t">' + esc(a.name) + '</div><div class="eb-d">' + esc(a.desc || '') + '</div></span>' +
          '<span class="eb-price' + (Number(a.price) === 0 ? ' eb-price--free' : '') + '">' + (Number(a.price) === 0 ? 'FREE' : money(a.price)) + '</span></button>';
      }).join('') +
      '<button type="button" class="eb-skiplink" data-eb-skip>No thanks, continue without extras</button>';
    el.querySelectorAll('.eb-choice').forEach(function (b) {
      b.onclick = function () {
        var k = b.dataset.k;
        state.addons = state.addons.indexOf(k) !== -1 ? state.addons.filter(function (x) { return x !== k; }) : state.addons.concat([k]);
        renderAddons(el); syncSummary(); syncNext();
      };
    });
    el.querySelector('[data-eb-skip]').onclick = function () { state.addons = []; advance(); };
  }

  function chosenLens() {
    var all = CFG.catalogs.prescription.concat(CFG.catalogs.sunglasses, CFG.catalogs.nonrx);
    return all.find(function (l) { return l.id === state.lens; }) || null;
  }
  function chosenAddons() { return CFG.addons.filter(function (a) { return state.addons.indexOf(a.id) !== -1; }); }
  function pdString() {
    return state.rx.pdMode === 'single' ? 'Single | ' + state.rx.pd : 'Dual | R ' + state.rx.pdR + ' / L ' + state.rx.pdL;
  }
  function eyeString(eye) {
    var e = state.rx[eye];
    var ax = parseFloat(e.cyl) !== 0 ? ' | x' + String(e.axis).padStart(3, '0') : '';
    return fmtP(e.sph) + ' | ' + fmtP(e.cyl) + ax;
  }
  var typeLabel = function () {
    return { prescription: 'Prescription', sunglasses: 'Sunglasses', nonrx: 'Non-Prescription', frame: 'Frame Only' }[state.type];
  };

  function buildItems(pairId) {
    var v = currentVariant();
    var lens = chosenLens();
    var frameProps = { 'Prescription Type': typeLabel(), '_pair_id': pairId };
    if (state.type === 'prescription' || state.type === 'sunglasses') {
      frameProps['Method'] = 'Entered Manually';
      frameProps['Lens'] = lens.name;
      if (state.method === 'manual') {
        frameProps['OD (Right)'] = eyeString('od');
        frameProps['OS (Left)'] = eyeString('os');
        frameProps['PD'] = pdString();
      }
    } else if (state.type === 'nonrx') {
      frameProps['Lens'] = lens.name;
    }
    if (state.forName) frameProps['For'] = state.forName;
    if (state.notes) frameProps['Order Notes'] = state.notes;
    var items = [{ id: v.id, quantity: 1, properties: frameProps }];
    if (lens) items.push({ id: Number(lens.variantId), quantity: 1, properties: { '_pair_id': pairId, 'Frame': frameName(v) } });
    chosenAddons().forEach(function (a) {
      items.push({ id: Number(a.variantId), quantity: 1, properties: { '_pair_id': pairId, 'Frame': frameName(v) } });
    });
    return items;
  }

  function renderReview(el) {
    var v = currentVariant();
    var lens = chosenLens(), adds = chosenAddons();
    var rxHtml = '';
    if ((state.type === 'prescription' || state.type === 'sunglasses') && state.method === 'manual') {
      rxHtml = '<div class="eb-row"><span class="eb-muted">OD (Right)</span><b>' + eyeString('od') + '</b></div>' +
        '<div class="eb-row"><span class="eb-muted">OS (Left)</span><b>' + eyeString('os') + '</b></div>' +
        '<div class="eb-row"><span class="eb-muted">PD</span><b>' + pdString() + '</b></div>';
    }
    if (state.rx.file) rxHtml += '<div class="eb-row"><span class="eb-muted">Rx file</span><b>' + esc(state.rx.file) + '</b></div>';
    el.innerHTML = '<h2>Please Review the Order</h2>' +
      '<div class="eb-rev">' +
      '<div class="eb-row"><b>' + esc(frameName(v)) + '</b><b>' + money(v.price) + '</b></div>' +
      '<div class="eb-row"><span class="eb-muted">Type</span><b>' + typeLabel() + '</b></div>' +
      (lens ? '<div class="eb-row"><span class="eb-muted">Lens</span><b>' + esc(lens.name) + ' · ' + (Number(lens.price) === 0 ? 'FREE' : money(lens.price)) + '</b></div>' : '') +
      adds.map(function (a) {
        return '<div class="eb-row"><span class="eb-muted">Add-on</span><b>' + esc(a.name) + ' · ' + (Number(a.price) === 0 ? 'FREE' : money(a.price)) + '</b></div>';
      }).join('') +
      rxHtml +
      '</div>' +
      '<div class="eb-rev"><label class="eb-f" for="eb-forname">Who are these for? (first name, optional)</label>' +
      '<input type="text" id="eb-forname" maxlength="40" placeholder="e.g. Mia" value="' + esc(state.forName) + '"></div>' +
      '<div class="eb-rev"><label class="eb-f" for="eb-notes">Order notes</label>' +
      '<textarea id="eb-notes" rows="2" placeholder="Anything we should know?">' + esc(state.notes) + '</textarea></div>' +
      '<div data-eb-done style="display:none"></div>';
    el.querySelector('#eb-forname').oninput = function (e) { state.forName = e.target.value; };
    el.querySelector('#eb-notes').oninput = function (e) { state.notes = e.target.value; };
    if (state.added) renderSuccess();
  }

  function pairGroupsFromCart(cart) {
    var g = {};
    (cart.items || []).forEach(function (i) {
      var pid = i.properties && i.properties._pair_id;
      if (pid) { (g[pid] = g[pid] || []).push(i); }
    });
    return Object.keys(g).map(function (k) { return g[k]; });
  }
  function pairLabel(group) {
    /* Truncated form: frame — variant · lens · +N add-on(s).
       cart.js lists newest-first, so the LAST non-frame item is the lens. */
    var frame = group.find(function (i) { return i.properties && i.properties['Prescription Type']; }) || group[0];
    var parts = group.filter(function (i) { return i !== frame; }).map(function (i) { return i.product_title; });
    var t = frame.product_title + (frame.variant_title ? ' — ' + frame.variant_title : '');
    if (!parts.length) return t;
    var named = parts[parts.length - 1];
    var extra = parts.length - 1;
    return t + ' · ' + named + (extra > 0 ? ' · +' + extra + ' add-on' + (extra > 1 ? 's' : '') : '');
  }
  /* Success screen is cart-aware: pair count comes from the REAL cart
     (distinct _pair_id values via /cart.js), so it survives page loads. */
  function renderSuccess() {
    var d = $('[data-eb-done]'); if (!d) return;
    d.style.display = 'block';
    var render = function (pairs) {
      var multi = pairs && pairs.length >= 2;
      var middle;
      if (multi) {
        middle = '<div class="eb-rev">' + pairs.map(function (g, i) {
          var total = g.reduce(function (sum, it) { return sum + it.line_price; }, 0);
          return '<div class="eb-prow">' +
            '<span class="eb-prow__label">Pair ' + (i + 1) + '</span>' +
            '<span class="eb-prow__desc">' + esc(pairLabel(g)) + '</span>' +
            '<b class="eb-prow__price">' + money(total / 100) + '</b></div>';
        }).join('') + '</div>';
      } else {
        middle = '<p class="eb-hint" style="display:flex;gap:6px;align-items:flex-start"><span>🦊</span><span>' +
          esc(CFG.copy.educationTip).replace(/2nd frame 50% off/i, '<b>2nd frame 50% off</b>') +
          '</span></p>';
      }
      var secondaryLabel = multi ? 'Add another pair' : (CFG.copy.secondPairLabel || '2nd frame 50% off');
      d.innerHTML =
        '<div class="eb-confirmbox eb-confirmbox--good"><span>🎉</span><span><b>Pair added to cart!</b></span></div>' +
        middle +
        '<a class="eb-cta" style="display:block;text-align:center;text-decoration:none" href="/cart">Review cart</a>' +
        '<a class="eb-ghost" href="' + esc(CFG.urls.secondPair) + '">' + esc(secondaryLabel) + '</a>';
      // Primary button now goes to /cart (review/modify), not straight to checkout,
      // so the Rx-reuse stash is NOT cleared here — it clears at the real checkout
      // (cart's name="checkout" button, caught by eyebuddy-pair-sync.js).
      d.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) { render(pairGroupsFromCart(cart)); })
      .catch(function () { render(null); });
  }
  /* ---------- summary + nav ---------- */
  function pairSubtotal() {
    var v = currentVariant();
    var lens = chosenLens();
    var addSum = chosenAddons().reduce(function (s, a) { return s + Number(a.price); }, 0);
    return Number(v.price) + (lens ? Number(lens.price) : 0) + addSum;
  }
  function syncSummary() {
    var v = currentVariant();
    var lens = chosenLens(), adds = chosenAddons();
    var addSum = adds.reduce(function (s, a) { return s + Number(a.price); }, 0);
    $('[data-eb-sumframe]').textContent = money(v.price);
    $('[data-eb-lensrow]').style.display = lens ? 'flex' : 'none';
    if (lens) $('[data-eb-sumlens]').textContent = Number(lens.price) === 0 ? 'FREE' : money(lens.price);
    $('[data-eb-addonrow]').style.display = adds.length ? 'flex' : 'none';
    if (adds.length) $('[data-eb-sumaddons]').textContent = addSum === 0 ? 'FREE' : money(addSum);
    $('[data-eb-sumtotal]').textContent = money(pairSubtotal());
  }
  function syncCartRow() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var pairs = {};
      var total = 0;
      cart.items.forEach(function (i) {
        total += i.line_price;
        if (i.properties && i.properties._pair_id) pairs[i.properties._pair_id] = 1;
      });
      var n = Object.keys(pairs).length;
      var row = $('[data-eb-cartrow]');
      if (n > 0) {
        row.style.display = 'flex';
        $('[data-eb-cartcount]').textContent = 'In cart: ' + n + ' pair' + (n > 1 ? 's' : '') + ' · 2nd frame 50% off at checkout';
        $('[data-eb-carttotal]').textContent = money(total / 100);
      } else row.style.display = 'none';
    }).catch(function () { });
  }
  function canContinue() {
    if (state.busy) return false;
    switch (cur()) {
      case 'type': return !!state.type;
      case 'rx': return rxValid();
      case 'lens': return !!state.lens;
      case 'addons': return true;
      case 'review': return !state.added;
    }
  }
  function syncNext() {
    var n = $('[data-eb-next]');
    n.disabled = !canContinue();
    n.textContent = state.busy ? 'Adding…' :
      state.added ? 'Added to cart ✓' :
        cur() === 'review' ? 'Add to Cart' :
          cur() === 'rx' ? 'Save and Continue' : 'Continue';
  }
  function advance() {
    if (stepIdx < flowSteps().length - 1) { stepIdx++; }
    render();
  }

  /* ---------- cart add ---------- */
  function rxFileObj() {
    var inp = $('[data-eb-rxfile]');
    return inp && inp.files && inp.files[0] ? inp.files[0] : null;
  }
  function addToCart() {
    var pairId = 'eb-' + Date.now();
    var items = buildItems(pairId);
    var file = rxFileObj();
    var errBox = $('[data-eb-adderror]');
    if (errBox) { errBox.style.display = 'none'; errBox.textContent = ''; }
    state.busy = true; syncNext();

    function done() {
      state.busy = false; state.added = true;
      if (state.method === 'manual' && (state.type === 'prescription' || state.type === 'sunglasses')) rxStashSave();
      syncNext(); syncCartRow(); renderSuccess(); toast('Pair added ✓');
    }
    function fail(err) {
      /* NEVER fail silently: log the real error, show a persistent inline message. */
      console.error('[eb-rxflow] add to cart failed:', err);
      state.busy = false; syncNext();
      var box = $('[data-eb-adderror]');
      if (box) {
        box.textContent = 'Something went wrong adding this to the cart — please try again or contact us';
        box.style.display = 'block';
      }
      toast('Could not add to cart');
    }
    function addJson(list) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list })
      }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) {
          throw new Error(j.description || ('HTTP ' + r.status));
        });
        return r.json();
      });
    }

    if (!file) {
      addJson(items).then(done).catch(fail);
      return;
    }
    /* Rx file attached: the frame line goes as a real multipart form POST so
       Shopify hosts the file (properties[Rx File] appears as a link on the
       order). Lens/add-ons follow via JSON with the same _pair_id. */
    var frame = items[0];
    var fd = new FormData();
    fd.append('id', String(frame.id));
    fd.append('quantity', '1');
    Object.keys(frame.properties).forEach(function (k) {
      fd.append('properties[' + k + ']', frame.properties[k]);
    });
    fd.append('properties[Rx File]', file, file.name);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('multipart add failed: ' + t.slice(0, 200)); });
        return r.json();
      })
      .then(function () {
        var rest = items.slice(1);
        return rest.length ? addJson(rest) : null;
      })
      .then(done)
      .catch(fail);
  }

  /* ---------- wire up ---------- */
  $('[data-eb-form]').addEventListener('submit', function (e) { e.preventDefault(); });
  $('[data-eb-next]').addEventListener('click', function () {
    if (!canContinue()) return;
    if (cur() === 'review') { addToCart(); return; }
    advance();
  });
  $('[data-eb-back]').addEventListener('click', function () {
    if (stepIdx > 0 && !state.added) { stepIdx--; render(); }
  });

  /* ---------- slide-over panel: open/close, focus trap, scroll lock ---------- */
  var panel = $('[data-eb-panel]');
  var scrim = $('[data-eb-scrim]');
  var closeBtn = $('[data-eb-close]');
  var lastFocus = null, keyHandler = null, hideTimer = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelFocusables() {
    if (!panel) return [];
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
  }
  function onPanelKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
    if (e.key === 'Tab') {
      var f = panelFocusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function openPanel() {
    if (!panel || panel.getAttribute('data-open') === '1') return;
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    lastFocus = document.activeElement;
    scrim.hidden = false; panel.hidden = false;
    document.documentElement.classList.add('eb-scroll-lock');
    document.body.classList.add('eb-scroll-lock');
    // Force a reflow to commit the closed state, then add --open synchronously so
    // the slide transition runs. (rAF is throttled in non-painting/background tabs,
    // which would leave the panel open logically but stuck off-screen.)
    void panel.offsetWidth;
    scrim.classList.add('eb-rxflow-scrim--open');
    panel.classList.add('eb-rxflow-panel--open');
    panel.setAttribute('data-open', '1');
    keyHandler = onPanelKey;
    document.addEventListener('keydown', keyHandler, true);
    if (closeBtn) closeBtn.focus();
  }
  function closePanel() {
    if (!panel || panel.getAttribute('data-open') !== '1') return;
    scrim.classList.remove('eb-rxflow-scrim--open');
    panel.classList.remove('eb-rxflow-panel--open');
    document.documentElement.classList.remove('eb-scroll-lock');
    document.body.classList.remove('eb-scroll-lock');
    panel.removeAttribute('data-open');
    if (keyHandler) { document.removeEventListener('keydown', keyHandler, true); keyHandler = null; }
    var hide = function () { panel.hidden = true; scrim.hidden = true; };
    if (reduceMotion) hide(); else hideTimer = setTimeout(hide, 340);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  // triggers live outside [data-eb-rxflow] (in the product form), so delegate on document
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-eb-rx-open]');
    if (t) { e.preventDefault(); openPanel(); }
  });
  if (scrim) scrim.addEventListener('click', closePanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);

  /* follow theme variant picker (price + name stay in sync) */
  var lastVid = null;
  setInterval(function () {
    var v = currentVariant();
    if (v.id !== lastVid) {
      lastVid = v.id;
      syncSummary();
      if (cur() === 'review' && !state.added) render();
    }
  }, 700);

  document.body.classList.add('eb-rxflow-active');
  render();
  syncCartRow();
})();
